import React from "react";
import PropTypes from "prop-types";
import buttonStyles from "./button.module.scss";

const Button = ({
  title,
  onClick,
  variant
}) => {

  return (
    <button
      className={ `${buttonStyles.button} ${variant === 'inverted' ? buttonStyles.inverted : ''} ${variant === 'unsure' ? 'unsure' : ''}` }
      onClick={onClick}
      aria-label={`Select ${title}`}
    >
      {title}
    </button>
  )
};

Button.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  variant: PropTypes.string
}

export default Button;
